import { Component } from '@angular/core';

@Component({
  selector: 'win-not-authorized',
  styleUrls: ['not-authorized.component.scss'],
  template: `
  <h2 style="text-align:center;">Access Denied</h2>
<br />
<br />
<h3>You don't have permission to access the page you are trying for. Please restrict your self to the Menu option, you can see</h3>


  `
})

export class NotAuthorizedComponent {

  constructor() { }
}
